module.exports = __webpack_public_path__ + "static/media/nl.7d7e874b.svg";